import { MasterDialog } from "#common/Dialog/Dialog"
import PERMISOS from "#constants/perfiles"
import { FORMATS } from "#core/constants"
import { useApiSend } from "#hooks/useApiSend"
import { UseHasPermission } from "#hooks/useHasPermission"
import { UseVacationContext } from "#vacation/contexts/VacationContext"
import { vacationPost, vacationPut } from "#vacation/services/api"
import dayjs from "dayjs"
import { useCallback, useEffect, useMemo, useState } from "react"
import { toast } from "react-toastify"
import VacationRequest from "./VacationRequest"

export default function VacationRequestDialog() {
	const {
		vacation,
		openRequest: open,
		setOpenRequest: setOpen,
		refresh,
	} = UseVacationContext()

	const is_rh = UseHasPermission(PERMISOS.RH)
	const [data, setData] = useState({})
	const [disabled, setDisabled] = useState(false)
	const [disabledCancelar, setDisabledCancelar] = useState(false)

	const success = useCallback(() => {
		setOpen(false)
		refresh()
	}, [setOpen, refresh])

	const end = () => {
		setDisabled(false)
		setDisabledCancelar(false)
	}
	const { fetch: fetchPost } = useApiSend(vacationPost, { success, end })
	const { fetch: fetchPut } = useApiSend(vacationPut, { success, end })

	const days_remaining = useMemo(() => {
		let days_remaining = vacation.available_days
		if (vacation?.days) days_remaining += vacation.days

		return days_remaining
	}, [vacation.available_days, vacation.days])

	const available_days = vacation.available_days - data.days_taken
	const fetch = useCallback(() => {
		if (!is_rh && available_days < 0) {
			toast.error("No puedes solicitar vacaciones que superen tus días libres")
			return
		}
		setDisabled(true)
		setDisabledCancelar(true)
		const data_send = {
			date_start: data.start.format("YYYY-MM-DD"),
			date_end: data.end.format("YYYY-MM-DD"),
		}

		if (vacation?.id) {
			fetchPut(vacation.id, data_send)
		} else {
			data_send.colaborador = vacation.colaborador
			fetchPost(data_send)
		}
	}, [
		available_days,
		data.end,
		data.start,
		fetchPost,
		fetchPut,
		is_rh,
		vacation.colaborador,
		vacation.id,
	])

	useEffect(() => {
		if (!is_rh && available_days < 0) {
			setDisabled(true)
			return
		}
		if (!data.start?.isValid() || !data.end?.isValid()) {
			setDisabled(true)
			return
		}
		if (data.start > data.end) {
			setDisabled(true)
			return
		}
		setDisabled(false)
	}, [available_days, data.end, data.start, is_rh])

	const buttons = useMemo(
		() => [
			{ label: "Solicitar", onClick: fetch, disabled },
			{ label: "Cancelar", onClick: () => setOpen(false), disabled: disabledCancelar },
		],
		[disabled, disabledCancelar, fetch, setOpen]
	)

	return (
		<MasterDialog {...{ open, setOpen, buttons, maxWidth: "sm" }}>
			<VacationRequest
				colaborador={vacation.colaborador}
				available_days={days_remaining}
				setData={setData}
				defaultValue={{
					start: vacation?.date_start
						? dayjs(vacation?.date_start, FORMATS.DATE_FORMAT)
						: null,
					end: vacation?.date_end ? dayjs(vacation?.date_end, FORMATS.DATE_FORMAT) : null,
				}}
			/>
		</MasterDialog>
	)
}
